import ModifierModal from "./ModifierModal.js";
import ModifierComboParentContainer from "./ModifierComboParentContainer.js"

// Returns Modifier Categories

export default function ModifierCategoryModal(props) {
    let modifiers;
    if (props.modifierCategoryDetails.itemUsageTypeName === "Regular") { // Regular Modifier Category
        modifiers = props.modifierCategoryDetails.mods?.map((item, index) => {
            let currentObj = "";
            let isChecked = "";
            let fieldName = "";
            if (props.modifierCategoryDetails.type === "Radio") { // Radio
                fieldName = `RadioModCatId${props.modifierCategoryDetails.modCategoryId}`;
                currentObj = props.productFormDataMods.find((item) => item.fieldName === fieldName);
                isChecked = currentObj[fieldName];
            } else if (props.modifierCategoryDetails.type === "Check") { // Check
                fieldName = `CheckModCatId${props.modifierCategoryDetails.modCategoryId}ModId${item.modId}`;
                currentObj = props.productFormDataMods.find((item) => item.fieldName === fieldName);
                isChecked = currentObj[fieldName];
            } else if (props.modifierCategoryDetails.type === "Substitution") { // Substitution
                fieldName = `SubRadioModCatId${props.modifierCategoryDetails.modCategoryId}`;
                currentObj = props.productFormDataMods.find((item) => item.fieldName === fieldName);
                isChecked = currentObj[fieldName];
            }
            return (<ModifierModal 
                key={item.modId}
                modifierDetails={item} 
                type={props.modifierCategoryDetails.type}
                modCatId={props.modifierCategoryDetails.modCategoryId}
                handleModFormChange={props.handleModFormChange}
                isChecked={isChecked} // determined by productFormDataMods (mapped modifiers from productFormData)
                addToCartError={props.addToCartError}
                currentLocation={props.currentLocation}
                priceInc={props.priceInc}
                />);
        })
    } else if (props.modifierCategoryDetails.itemUsageTypeName === "Combo") { // Modifier Combo Category
        let fieldName = `ModComboModCatId${props.modifierCategoryDetails.modCategoryId}`;
        let currentObj = props.productFormDataMods.find((item) => item.fieldName === fieldName);
        return <ModifierComboParentContainer
            modifierCategoryDetails={props.modifierCategoryDetails}
            modCatId={props.modifierCategoryDetails.modCategoryId}
            productFormDataMods={props.productFormDataMods}
            comboFormData={currentObj} // productFormData filtered to just pass current combo
            handleModifierComboSelect={props.handleModifierComboSelect}
            handleRemoveModifierComboFromProduct={props.handleRemoveModifierComboFromProduct}
            addToCartError={props.addToCartError}
            currentLocation={props.currentLocation}
        />
    }

    // Error Status & Styling
    const validationObj = props.productFormDataModCatValidation.find((modCat) => {
        return modCat.ModCatId === props.modifierCategoryDetails.modCategoryId;
    });
    let badgeClassStyles = "";
    if (validationObj.HasError) {
        badgeClassStyles = "wo-req--bad";
    } else {
        badgeClassStyles = "";
    }
    // Choose Amount
    let chooseAmountText = "";
    if (props.modifierCategoryDetails.minValue == 0) {
        chooseAmountText = `Choose up to ${props.modifierCategoryDetails.maxValue}`
    } else if (props.modifierCategoryDetails.minValue == props.modifierCategoryDetails.maxValue) {
        chooseAmountText = `Choose ${props.modifierCategoryDetails.maxValue}`
    } else {
        chooseAmountText = `Choose between ${props.modifierCategoryDetails.minValue} - ${props.modifierCategoryDetails.maxValue}`
    }

    /* The "Choose N" chip turns red when the category fails validation — that is
       the only signal the customer gets about what is still missing, so it must
       stay next to the heading rather than move into a summary elsewhere. */
    return (
        <>
            <div className="col-12 wo-opt__head">
                <span className="wo-opt__name">{props.modifierCategoryDetails.modCategoryName}</span>
                {props.modifierCategoryDetails.maxValue && <span className={`wo-req ${badgeClassStyles}`}>{chooseAmountText}</span>}
            </div>
            {modifiers}
        </>
    )
}